'use strict';

window.setupShortCourseSessions = function (widgetID){
	var oRow = $('#shortcoursesessions_' + widgetID);

	oRow.find('.session-date').change(function(){
		var curOpt = $(this).find('option:selected');

		/* Clear the seats list, and rebuild it from the current session available seats */
		oRow.find('.session-seats').empty();
		for (var i = 1; i <= curOpt.data('availableseats'); i++) {
			oRow.find('.session-seats').append($('<option value="' + i + '">' + $.i18n._(13349, [i]) + '</option>'));
		}

		GAPush({'product_price' : curOpt.data('tuitionprice')});
	});

	oRow.find('.short-courses-form').submit(function(e) {
		e.preventDefault();

		var courseId = $(this).data('courseid');
		var sessionId = $(this).find('.session-date').val();
		var tuitiontypecode = $(this).find('input[name=tuitionTypeId]:checked').data('tuitiontype');
		var seats = $(this).find('.session-seats').val();
		var CourseName = $(this).data('short-course-name');
		var CampusName = $(this).data('short-course-campus');

		if (tuitiontypecode == undefined) {
			tuitiontypecode = $(this).find('.session-date').find('option:selected').data('tuitiontype');
		}

		if ((tuitiontypecode !== undefined) && (courseId !== undefined) && (seats.length > 0)) {
			var CartData = {
				"sessionID": sessionId,
				"seats": seats,
				"tuitiontypecode":tuitiontypecode
			};

			addToCart('Course',CartData,function() {
				oRow.find('.short-courses-added').find('.course-session').empty().html(oRow.find('.session-date').find('option:selected').text());
				oRow.find('.short-courses-added').find('.course-seats').empty().html(seats);

				oRow.find('.short-courses-form').hide();
				oRow.find('.short-courses-added').fadeIn();

			},null,{CourseName:CourseName,CampusName:CampusName});
		}
	});
}